<template>
  <section class="planes-banner d-flex flex-column justify-content-center align-items-center text-center">
    <div class="overlay"></div>

    <div class="container position-relative text-white">
      <!-- Título -->
      <h1 class="display-4 fw-bold gradient-text" data-aos="zoom-in">
        <i class="fas fa-dumbbell me-2"></i> ¡Transforma tu cuerpo en Victoria Fitness Center! <i class="fas fa-dumbbell ms-2"></i>
      </h1>
      <p class="lead mt-3" data-aos="fade-up" data-aos-delay="200">
        ¡Donde la motivación se convierte en resultados!
      </p>

      <!-- Ubicación -->
      <p class="mt-3" data-aos="fade-up" data-aos-delay="300">
        <i class="bi bi-geo-alt-fill text-danger me-2"></i>
        Ubicado en el corazón de Páez, con planes accesibles, entrenadores dedicados y un ambiente que te impulsa a dar lo mejor de ti.
      </p>

      <!-- Planes -->
      <div class="row mt-5 justify-content-center g-4">
        <div v-for="(plan, index) in plans" :key="index" class="col-md-4 d-flex">
          <div class="card plan-card w-100" data-aos="flip-up" :data-aos-delay="index*200">
            <div v-if="plan.badge" class="plan-badge">{{ plan.badge }}</div>
            <div class="card-body d-flex flex-column text-center">
              <h5 class="card-title fw-bold gradient-text">
                <i class="bi bi-lightning-charge-fill text-warning me-2"></i>{{ plan.name }}
              </h5>
              <p class="descripcion mb-2">{{ plan.desc }}</p>
              <p class="card-price fw-bold">${{ plan.price }}</p>
              <ul class="list-unstyled mt-3">
                <li v-for="item in plan.details" :key="item" class="mb-2">
                  <i class="bi bi-check2-circle text-success me-2"></i>{{ item }}
                </li>
              </ul>
              <p class="extra-text mt-3">{{ plan.extra }}</p>
              <RouterLink to="/reserva" class="btn btn-warning fw-bold mt-3 w-100 pulse-btn mt-auto">
                <i class="fas fa-bolt me-2"></i> ¡Quiero este plan!
              </RouterLink>
            </div>
          </div>
        </div>
      </div>

      <!-- Tarjetas extra -->
      <div class="row mt-5 justify-content-center g-4">
        <!-- Estacionamiento -->
        <div class="col-md-4 d-flex">
          <div class="card plan-card w-100" data-aos="flip-up" data-aos-delay="200">
            <div class="card-body d-flex flex-column text-center">
              <h5 class="card-title fw-bold gradient-text">
                <i class="bi bi-car-front-fill text-primary me-2"></i> Estacionamiento
              </h5>
              <p class="descripcion mb-2">Tu vehículo protegido mientras tú te transformas.</p>

              <div class="d-flex justify-content-around align-items-center flex-wrap mt-4 estacionamiento-precios">
                <div class="precio-item">
                  <p class="card-price fw-bold">$5</p>
                  <p class="detalle text-dark">Motos / Mensual</p>
                </div>
                <div class="precio-item">
                  <p class="card-price fw-bold">$7</p>
                  <p class="detalle text-dark">Carros / Mensual</p>
                </div>
              </div>

              <div class="benefits mt-4">
                <p><i class="bi bi-shield-lock-fill text-primary me-2"></i> Seguridad las 24 horas</p>
                <p><i class="bi bi-camera-video-fill text-primary me-2"></i> Cámaras de vigilancia activas</p>
                <p><i class="bi bi-lightning-charge text-warning me-2"></i> Iluminación y fácil acceso</p>
                <p><i class="bi bi-person-lines-fill text-secondary me-2"></i> Personal de vigilancia</p>
                <p><i class="bi bi-gear-fill text-secondary me-2"></i> Mantenimiento constante del área</p>
              </div>

              <p class="extra-text mt-3">Acceso rápido y seguro al gimnasio. 🚘</p>

              <RouterLink to="/reserva" class="btn btn-warning fw-bold mt-4 w-100 pulse-btn mt-auto">
                <i class="bi bi-car-front-fill me-2"></i> ¡Quiero estacionar aquí!
              </RouterLink>
            </div>
          </div>
        </div>

        <!-- Promos Nuevos Ingresos -->
        <div class="col-md-4 d-flex">
          <div class="card plan-card w-100" data-aos="flip-up" data-aos-delay="400">
            <div class="card-body d-flex flex-column text-center">
              <h5 class="card-title fw-bold gradient-text">
                <i class="bi bi-gift-fill text-danger me-2"></i> Promos Nuevos Ingresos
              </h5>
              <p class="descripcion mb-2">Empieza con todo y aprovecha los precios especiales.</p>

              <div class="d-flex justify-content-around align-items-center flex-wrap mt-4 estacionamiento-precios">
                <div class="precio-item">
                  <p class="card-price fw-bold">$15</p>
                  <p class="detalle text-dark">1er Mes / 22 BCV</p>
                </div>
                <div class="precio-item">
                  <p class="card-price fw-bold">$13</p>
                  <p class="detalle text-dark">2do Mes / 20 BCV</p>
                </div>
                <div class="precio-item">
                  <p class="card-price fw-bold">$18</p>
                  <p class="detalle text-dark">3er Mes / 24 BCV</p>
                </div>
              </div>

              <hr class="my-4">
              <p>🎉 Ven con tus panas y ahorra más:</p>
              <p>2 personas: $28 | 3 personas: $40 | 4 personas: $55</p>

              <p class="extra-text mt-3">Ideal para nuevos socios que quieren empezar con energía y descuentos.</p>

              <RouterLink to="/reserva" class="btn btn-warning fw-bold mt-4 w-100 pulse-btn mt-auto">
                <i class="bi bi-gift-fill me-2"></i> ¡Aprovechar promoción!
              </RouterLink>
            </div>
          </div>
        </div>

        <!-- Entrenadores Profesionales -->
        <div class="col-md-4 d-flex">
          <div class="card plan-card w-100" data-aos="flip-up" data-aos-delay="600">
            <div class="card-body d-flex flex-column text-center">
              <h5 class="card-title fw-bold gradient-text">
                <i class="bi bi-person-badge-fill text-success me-2"></i> Entrenadores Profesionales
              </h5>
              <p class="descripcion mb-2">Guía personalizada para alcanzar tus metas físicas.</p>

              <div class="d-flex justify-content-around align-items-center flex-wrap mt-4 estacionamiento-precios">
                <div class="precio-item">
                  <p class="card-price fw-bold">$5</p>
                  <p class="detalle text-dark">Semanal</p>
                </div>
                <div class="precio-item">
                  <p class="card-price fw-bold">$15</p>
                  <p class="detalle text-dark">Mensual</p>
                </div>
              </div>

              <div class="benefits mt-4">
                <p><i class="bi bi-heart-pulse-fill text-success me-2"></i> Rutinas adaptadas a ti</p>
                <p><i class="bi bi-chat-dots-fill text-success me-2"></i> Seguimiento constante</p>
                <p><i class="bi bi-stars text-warning me-2"></i> Resultados garantizados</p>
                <p><i class="bi bi-journal-text text-primary me-2"></i> Plan de entrenamiento individualizado</p>
                <p><i class="bi bi-people-fill text-primary me-2"></i> Asesoría en nutrición y hábitos saludables</p>
              </div>

              <p class="extra-text mt-3">Nuestros coaches te motivan cada día para alcanzar tu mejor versión</p>

              <RouterLink to="/reserva" class="btn btn-warning fw-bold mt-4 w-100 pulse-btn mt-auto">
                <i class="fas fa-dumbbell me-2"></i> ¡Quiero mi entrenador!
              </RouterLink>
            </div>
          </div>
        </div>
      </div>

      <!-- CTA -->
      <div class="row mt-5 justify-content-center g-4">
        <div class="col-md-8">
          <div class="card cta-card" data-aos="zoom-in" data-aos-delay="800">
            <div class="card-body text-center text-white">
              <p><i class="bi bi-instagram me-2"></i> Síguenos en <strong>@victoriafitnesscenter</strong></p>
              <p><i class="bi bi-telephone-fill me-2"></i> ¡Contáctanos hoy y asegura tu cupo!</p>
              <a
                href="https://wa.me/584143516746"
                target="_blank"
                rel="noopener noreferrer"
                class="btn btn-light btn-lg fw-bold shadow-lg pulse-btn"
              >
                <i class="fas fa-rocket me-2"></i> ¡Empieza ahora tu transformación!
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>


<script setup>
const plans = [
  { 
    name: '3 Meses', 
    price: 45, 
    desc: 'Perfecto para iniciar tu camino fitness.', 
    details: ['Acceso completo al gimnasio'], 
    extra: 'Empieza a construir tu hábito saludable hoy mismo.',
    badge: null 
  },
  { 
    name: '6 Meses', 
    price: 80, 
    desc: 'Comprométete con tu mejor versión.', 
    details: ['Acceso completo al gimnasio', 'Clases grupales'], 
    extra: 'Ideal para ver resultados reales y mejorar tu rendimiento.',
    badge: '⭐ Más popular' 
  },
  { 
    name: '12 Meses', 
    price: 130, 
    desc: 'Tu transformación completa, un año de disciplina y logros.', 
    details: ['Acceso completo al gimnasio', 'Clases grupales', 'Evaluaciones físicas periódicas'], 
    extra: 'La mejor inversión en ti y en tu bienestar a largo plazo.',
    badge: '🔥 Mejor valor' 
  }
]
</script>

<style scoped>
.planes-banner {
  position: relative;
  min-height: 100vh;
  background: url('@/assets/images/carruzel/gym2.webp') no-repeat center center;
  background-size: cover;
  padding: 3rem 1rem;
}

.overlay {
  position: absolute;
  top:0; left:0; right:0; bottom:0;
  background-color: rgba(0,0,0,0.55);
  z-index: 0;
}

.container.position-relative {
  z-index: 1;
  font-family: 'Open Sans', sans-serif;
}

h1, p, .card-title, .card-price, li {
  text-shadow: 1px 1px 6px rgba(0,0,0,0.6);
}

.plan-card {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 15px;
  transition: all 0.3s ease;
  background: rgba(255,255,255,0.95);
  color: #222;
  box-shadow: 0 8px 25px rgba(0,0,0,0.3);
}

.plan-card:hover {
  transform: translateY(-10px) scale(1.05);
  box-shadow: 0 16px 40px rgba(0,0,0,0.4);
}

.plan-card .card-body {
  flex: 1;
}

.card-price {
  font-size: 2rem;
  color: #F97316;
  text-shadow: 2px 2px 6px rgba(0,0,0,0.4);
}

.plan-badge {
  position: absolute;
  top: 12px;
  right: -35px;
  background: #F97316;
  color: #fff;
  font-weight: bold;
  padding: 5px 40px;
  transform: rotate(45deg);
  font-size: 0.85rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
}

.descripcion {
  font-size: 0.95rem;
  color: #111;
  font-weight: 500;
}

.extra-text {
  font-size: 0.9rem;
  color: #333;
  font-style: italic;
  margin-top: auto;
}

/* Precios dobles */
.estacionamiento-precios {
  gap: 1.5rem;
}

.precio-item {
  text-align: center;
}

.precio-item .card-price {
  font-size: 2rem;
  color: #F97316;
}

.precio-item .detalle {
  font-size: 1rem;
  color: #000;
  font-weight: 600;
}

/* CTA */
.cta-card {
  background: linear-gradient(135deg, #F97316, #FBBF24);
  border-radius: 18px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.35);
}

/* Botón animado */
.pulse-btn {
  transition: transform 0.2s;
  animation: pulse 1.5s infinite;
}
.pulse-btn:hover {
  transform: scale(1.05);
}
@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(249, 115, 22, 0.6); }
  70% { box-shadow: 0 0 0 15px rgba(249, 115, 22, 0); }
  100% { box-shadow: 0 0 0 0 rgba(249, 115, 22, 0); }
}
</style>
